import NProgress from 'nprogress';
import 'velocity-animate';

import config from './globals/config';
import setTrailerDrawerInfo from './set-trailer-drawer-info';
import videoLoad from './video-load';
import setTrailerDrawerTopNav from './set-trailer-drawer-top-nav';

export default function (
  playerLightbox,
  videoId,
  currentNum,
  trailerDrawerBG,
  trailerDrawerTitle,
  trailerDrawerInfoTitle,
  trailerDrawerDesktop,
  loadingSpinner,
  leftTrailer,
  rightTrailer,
  trailerDrawerInfoSeeMore,
  trailerDrawerInfoText
) {
  playerLightbox.velocity({
    opacity: 0,
  }, {
    duration: config.animationTiming,
    easing  : config.easing,

    complete: function () {
      setTrailerDrawerInfo(
        trailerDrawerBG,
        trailerDrawerTitle,
        trailerDrawerInfoTitle,
        trailerDrawerDesktop,
        trailerDrawerInfoSeeMore,
        trailerDrawerInfoText
      );

      videoLoad(loadingSpinner, videoId, config.myPlayer);
      setTrailerDrawerTopNav(leftTrailer, rightTrailer, currentNum);

      playerLightbox.velocity({
        opacity: 1,
      }, {
        duration: config.animationTiming,
        easing  : config.easing,
        delay   : config.animationTiming + 250,
        complete: function () {
          NProgress.done();
        },
      });
    },
  });
}
